import React, { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './Fade.module.scss'

const Fade = ({ show, className, children }) => {
  const [shouldRender, setRender] = useState(show)

  useEffect(() => {
    if (show) setRender(true)
  }, [show])

  const onAnimationEnd = () => {
    if (!show) setRender(false)
  }

  const fadeClass = useMemo(() => {
    return show
      ? classNames(className, styles.fadeIn)
      : classNames(className, styles.fadeOut)
  }, [show, className])

  return (
    shouldRender && (
      <div className={fadeClass} onAnimationEnd={onAnimationEnd}>
        {children}
      </div>
    )
  )
}

Fade.propTypes = {
  show: PropTypes.bool.isRequired,
  className: PropTypes.string,
  children: PropTypes.any,
}

export default Fade
